// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1094":"0000e22d","1420":"0b075a29","4296":"0000e22d","6092":"0000e22d"}[chunkId] + ".chunk.css";
};